module.exports = __webpack_public_path__ + "static/media/podium-star.e80517d9.svg";